// extracted by mini-css-extract-plugin
export var completionBody = "_k0-2";
export var completionCard = "_k0-0";
export var completionFooter = "_k0-3";
export var completionTitle = "_k0-1";